import { ObjectizerModel } from '@leverege/condition';
import { GlobalState, Selection } from '@leverege/ui-redux';
const TYPE = 'condition.Symbolizer';
function create(opts) {
  const defaultValue = opts?.defaultValue || null;
  const m = ObjectizerModel.create({
    defaultValue
  });
  m.type = TYPE;
  return m;
}
function symbolFor(model, obj, context) {
  const symbol = ObjectizerModel.getValue(model, {
    ...context,
    target: obj
  });
  const state = GlobalState.get();
  const {
    selected,
    rollover
  } = state.selection;
  const isSelected = Selection.isSelected(selected, obj.id);
  const isRollover = Selection.isSelected(rollover, obj.id);
  const isNormal = symbol == null || symbol === 'normal';
  if (isSelected && isRollover) {
    return `${isNormal ? '' : `${symbol}-`}rollover-selected`;
  }
  if (isSelected) {
    return `${isNormal ? '' : `${symbol}-`}selected`;
  }
  if (isRollover) {
    return `${isNormal ? '' : `${symbol}-`}rollover`;
  }
  return symbol;
}
export default {
  ...ObjectizerModel,
  create,
  symbolFor,
  name: 'Symbol by Condition',
  TYPE
};